import cn from "clsx";

type TProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
};
export const Button: React.FC<TProps> = ({ className, ...props }) => {
  return <button className={cn("btn", className)} {...props} />;
};
export const CircleButton: React.FC<TProps> = ({ className, ...props }) => {
  return <button className={cn("circleBtn", className)} {...props} />;
};
